<template>
  <TheDemo />
</template>

<script>
import TheDemo from '@/components/Demo/TheDemo.vue'

export default {
  name: 'PublicDemoPage',

  components: { TheDemo }
}
</script>
